import React from 'react'
import { ColorsEnum } from '../../constants/colors'
import { stationColumns } from '../../constants/stations'
import { useAppDispatch, useAppSelector } from '../../hooks/redux'
import { appSelectors, setIsArchive } from '../../redux/reducers/app'
import { stationSelectors } from '../../redux/reducers/station'
import { performHaptics } from '../../utils/performHaptics'
import BarButton from '../UI/buttons/BarButton'

const SectionButton = () => {
    const currentStation = useAppSelector(stationSelectors.currentStation)
    const isArchive = useAppSelector(appSelectors.isArchive)

    const dispatch = useAppDispatch()

    if (currentStation && !('archive' in stationColumns[currentStation.type])) {
        return <></>
    }

    const handlePress = () => {
        performHaptics()

        dispatch(setIsArchive(!isArchive))
    }

    const section = !isArchive ? 'Archiv' : 'Aktivní'
    const textColor = !isArchive ? ColorsEnum.PRIMARY : ColorsEnum.SUCCESS

    return (
        <BarButton
            backgroundColor="#FFFFFF"
            textColor={textColor}
            onPress={handlePress}
            contentStyle={{ width: 120 }}
        >
            {section}
        </BarButton>
    )
}

export default SectionButton
